export default "__VITE_ASSET__BmPMJykA__"